import * as types from '../types.js';

export default {

	html: `
		<style>
		</style>
		<form id="reverse-output" class="form" autocomplete="off">
			<div class="title">
				Estorno de saída
			</div>
			<div class="mtl">
				<input id="company_id" type="hidden">
				<input id="output_id" type="hidden">
				<label title="Selecione status abaixo do atual para reversão das operações">Status desejado:
					<input id="status" type="text" list="output_status" required>
				</label>
			</div>
			<div class="mtm">
				<button class='bn_Escape button'>Cancelar</button>
				<button class='bn_Enter button'>Estornar</button>
			</div>
		</form>
	`,

	form: 
	{
		selector: '#reverse-output',
		init(formset)
		{
			formset.form.eraseValues();
			Object.getPrototypeOf(this).init.call(this);
		},
	},
	
	fields: [
		{ properties: { selector: '#company_id' }, types: [] },
		{ properties: { selector: '#output_id' }, types: [] },
		{ properties: { selector: '#status' }, types: [types.opt_output_status(), types.datalist()] },
	]

};

